// Show "*" before sold date - REALTORS® Association of Edmonton (RAE VOW)
// https://loftyinc.atlassian.net/browse/CHIME-55774
export const showStarMLS = [588];

// Show "MLS®" format - CREA
// https://loftyinc.atlassian.net/browse/CHIME-66708
export const showRegisteredMLS = [588, 1017];

/**
 * 站点级商标写法判据：站点绑定的 MLS 组织中任意一个要求商标写法时，
 * 站点级静态文案（如搜索结果列表视图的表头列名）使用 "MLS®"。
 * 房源级文案仍按房源自身所属组织判断，不走这里。
 * https://loftyinc.atlassian.net/browse/CHIME-66708
 * @param {Array} mlsOrgs - 站点绑定的 MLS 组织列表
 * @returns {boolean}
 */
export const hasRegisteredMLS = (mlsOrgs) => {
    if (!Array.isArray(mlsOrgs)) {
        return false;
    }
    return mlsOrgs.some(org => showRegisteredMLS.includes(Number(org?.id)));
};

// 隐藏SEO模块和面包屑
// https://loftyinc.atlassian.net/browse/CHIME-26415
export const MLS_HIDE_SEO_BREADCRUMB_IDS = [526, 726];

// Banner图片以右下角为起点展示
// https://loftyinc.atlassian.net/browse/CHIME-59220
export const MLS_BANNER_BOTTOM_RIGHT_IDS = [585];

// https://loftyinc.atlassian.net/browse/CHIME-58348
export const MLS_ORGS = {
    BahamasMLS: {
        id: 878,
        name: 'BahamasMLS',
        defaultText: 'Courtesy of: The Bahamas MLS'
    },
};

export const BAHAMAS_MLS_ID = MLS_ORGS.BahamasMLS.id;

// Hide sold estimate block
// https://loftyinc.atlassian.net/browse/CHIME-65137
export const MLS_HIDE_SOLD_ESTIMATE_BLOCK = {
    reaVowMLS: {
        id: 588,
        name: 'REALTORS® Association of Edmonton (RAE VOW)',
    }
};

const MLS_HIDE_MAP_OBJ = new Map(
    Object.values(MLS_HIDE_SOLD_ESTIMATE_BLOCK).map(mls => [mls.id, mls])
);

/**
 * 1: above - show above the price
 * 2: under - show below the copy right part
 * 3: top - show right below the image
 * 4: imageTop - show above the hero image（暂无后端值，由白名单赋值，CHIME-69940）
 */
export const PROVIDED_POSITION_KEY = {
    above: 1,
    under: 2,
    top: 3,
    imageTop: 4
};

export const isHideSoldEstimateBlock = (house) => {
    const mlsId = Number(house?.mlsOrg?.id);
    if (!mlsId || isNaN(mlsId)) {
        return false;
    }
    return MLS_HIDE_MAP_OBJ.has(mlsId);
};

// Render listing broker attribution above the hero photo (layout1 detail page)
// MLS compliance: attribution must be visible without scrolling
// https://loftyinc.atlassian.net/browse/CHIME-69940
export const MLS_ATTRIBUTION_ABOVE_HERO = {
    wvMLS: {
        id: 81,
        name: 'Willamette Valley MLS (WVMLS)',
    }
};

const MLS_ATTRIBUTION_ABOVE_HERO_MAP = new Map(
    Object.values(MLS_ATTRIBUTION_ABOVE_HERO).map(mls => [mls.id, mls])
);

export const isAttributionAboveHero = (house) => {
    const mlsId = Number(house?.mlsOrg?.id);
    if (!mlsId || isNaN(mlsId)) {
        return false;
    }
    return MLS_ATTRIBUTION_ABOVE_HERO_MAP.has(mlsId);
};

export const getTemplate = (house, officeStatus, templateKey = 'template') => {
    if (!house || !house.mlsOrg || !house.mlsOrg[templateKey]) {
        return '';
    }
    if (house.mlsOrg.id === BAHAMAS_MLS_ID) {
        return officeStatus ? house.mlsOrg[templateKey] : MLS_ORGS.BahamasMLS.defaultText;
    }
    return house.mlsOrg[templateKey];
};

/**
 * @param {*} listingManagementType - 10 is office type's value - hard code
 */
export async function getOfficeStatus(listingIds, listingType, userId, listingManagementType = 10, axiosIns) {
    const axiosInstance = axiosIns || this.axiosIns;
    const res = await axiosInstance.post('/open-api/listing/mls/checkInOffice', {
        listingIds,
        soldFlag: listingType,
        listingManagementType,
        userId
    });
    return res?.data || {};
}

export async function getHouseOfficeStatus(data, agentId) {
    if (!data?.listings) {
        return data;
    }

    let list = data.listings || data.house || [];
    let listingIds = [];
    list.forEach(v => {
        if (v.mlsOrg?.id === BAHAMAS_MLS_ID) {
            listingIds.push(v.id);
        }
    });
    if (!listingIds.length) {
        return data;
    }

    const isSold = typeof data.listingType == 'string'
        ? data.listingType?.toLowerCase() === 'sold-listing'
        : data.listingType;
    const res = await getOfficeStatus(
        listingIds,
        isSold,
        agentId,
        10,
        this.axiosIns
    );
    if (!res) {
        return data;
    }

    data.listings.forEach(v => {
        if (listingIds.includes(v.id)) {
            v.isOfficeListed = res[v.id];
            v.mlsOrg.cardTemplate = getTemplate(v, res[v.id], 'cardTemplate');
            v.mlsOrg.template = getTemplate(v, res[v.id], 'template');
        }
    });
    return data;
}
